<template>
  <div class="text-center px-2">
    <v-container fill-height grid-list-md text-xs-center>
      <v-row align="center" justify="center">
        <v-col cols="12" align="left">
          <span class="termsAndConditionsTitle">{{$t('termsAndConditionsTitle')}}</span>
        </v-col>
        <v-col cols="12" align="left">
          {{$t('termsAndConditionsDescription')}}
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="6">
          <v-btn class="btnDisagree" color="grey lighten-1" @click="onTermsAndConditionDECLINE()">
            {{$t('disagree')}}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn  class="btnAgree"  dark @click="onTermsAndConditionACCEPT()">
            {{$t('agree')}}
          </v-btn>
        </v-col>

      </v-row>
    </v-container>



  </div>
</template>
<script>
//component that displays the terms and conditions in a dialog
  export default {
    name: 'termsAndConditions',
    data () {
      return {
        dialog: false,
      }
    },
      computed: {
    termsandcondition: {
      get: function() {
        return this.$store.state.isTermsAndCondition
      },
      /*set: function(newValue) {
        //set the new value in terms and condition
        this.$store.dispatch("setTermsAndCondition", newValue)
      }*/
    }
  },
      methods: {
    gotopage: function (page) {
      this.$router.push(page)
    },
    onTermsAndConditionACCEPT(){
      this.$store.dispatch('setTermsAndCondition',true)
//goto login
    this.gotopage("loginFirstTime")
    },
    onTermsAndConditionDECLINE(){
      this.$store.dispatch('setTermsAndCondition',false)
//exit
      this.gotopage("loginFirstTime")

    }
  }
  }
</script>
<style scoped>
.termsAndConditionsTitle{
font-weight: bold;
text-transform: capitalize;
}
.btnDisagree{
  border-radius: 999rem;
  text-transform: capitalize;

}
.btnAgree{
    border-radius: 999rem;
    text-transform: capitalize;
    color:white;
}
</style>